import { ReactElement, useState } from "react";
import "../components/MainContentHeader.scss";
import Terms from "../components/Terms";
import LandingHeader from "./components/LandingHeader";
import UploadSection from "./components/UploadSection";
import SearchSection from "./components/SearchSection";
import SampleSection from "../components/SampleSection";
import StatsSection from "../components/StatsSection";
import UrlScanSection from "./components/UrlScanSection";
import { ReactComponent as LinkIcon } from "../assets/icons/link-solid-full (1).svg";

export default function LandingPage(): ReactElement {
  const [mode, setMode] = useState("file");

  const tabIndex = mode === "file" ? 0 : mode === "search" ? 1 : 2;

  return (
    <>
      <Terms />
      <div className="main-vertical-divider">
        <div className="main-content-area">
          <LandingHeader />
          <div className="no-file-choosen-state-active">
            <div className="front-choice-section">
              <div
                className="front-choice-indicator"
                style={{ transform: `translateX(${tabIndex * 100}%)` }}
              />
              {["file", "search", "url"].map((tab) => (
                <button
                  key={tab}
                  className={`front-choice-title ${mode === tab ? "active" : ""}`}
                  onClick={() => setMode(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>

            {mode === "file" && <UploadSection />}
            {mode === "search" && <SearchSection />}

            {mode === "url" && <UrlScanSection />}

            <SampleSection />
            <StatsSection />
          </div>
        </div>
      </div>
    </>
  );
}
